import React, { useEffect, useState } from "react";
import axios from "axios";

const BoardManagement = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [boards, setBoards] = useState([]);
  const [boardName, setBoardName] = useState("");
  const [slug, setSlug] = useState("");
  const [editId, setEditId] = useState(null);

  /* =======================
     GET ALL BOARDS
  ======================= */
  const fetchBoards = () => {
    axios
      .get(`${API_BASE_URL}/boards`)
      .then((res) => setBoards(res.data.data))
      .catch(() => setBoards([]));
  };

  useEffect(() => {
    fetchBoards();
  }, []);

  /* =======================
     ADD / UPDATE BOARD
  ======================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = { boardName, slug };

    const apiCall = editId
      ? axios.put(`${API_BASE_URL}/boards/${editId}`, payload)
      : axios.post(`${API_BASE_URL}/boards`, payload);

    apiCall
      .then(() => {
        alert(editId ? "Board Updated" : "Board Added");
        resetForm();
        fetchBoards();
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong");
      });
  };

  /* =======================
     EDIT BOARD
  ======================= */
  const handleEdit = (board) => {
    setEditId(board._id);
    setBoardName(board.boardName);
    setSlug(board.slug);
  };

  /* =======================
     DELETE BOARD
  ======================= */
  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this board?")) return;

    axios
      .delete(`${API_BASE_URL}/boards/${id}`)
      .then(() => {
        alert("Board Deleted");
        fetchBoards();
      })
      .catch(() => alert("Delete failed"));
  };

  const resetForm = () => {
    setBoardName("");
    setSlug("");
    setEditId(null);
  };

  return (
    <>
      <style>{`
        body {
          background: #f4f6f8;
          font-family: Arial, sans-serif;
        }

        .container {
          max-width: 1000px;
          margin: 30px auto;
          background: #fff;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        h3 {
          border-left: 4px solid #007bff;
          padding-left: 10px;
          margin-bottom: 20px;
        }

        .form {
          display: flex;
          gap: 15px;
          margin-bottom: 20px;
        }

        .form input {
          flex: 1;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .form button {
          padding: 10px 18px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .save {
          background: #007bff;
          color: #fff;
        }

        .cancel {
          background: #6c757d;
          color: #fff;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #ddd;
          padding: 10px;
          text-align: left;
        }

        th {
          background: #f1f1f1;
        }

        .edit {
          background: #28a745;
          color: #fff;
          padding: 6px 12px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
        }

        .delete {
          background: #dc3545;
          color: #fff;
          padding: 6px 12px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          margin-left: 5px;
        }
      `}</style>

      <div className="container">
        <h3>Board Management</h3>

        {/* ADD / UPDATE FORM */}
        <form className="form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Board Name (e.g. CBSE)"
            value={boardName}
            onChange={(e) => setBoardName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Slug (e.g. cbse)"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            required
          />

          <button type="submit" className="save">
            {editId ? "Update" : "Save"}
          </button>

          {editId && (
            <button type="button" className="cancel" onClick={resetForm}>
              Cancel
            </button>
          )}
        </form>

        {/* BOARD LIST */}
        <table>
          <thead>
            <tr>
              <th>Board Name</th>
              <th>Slug</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {boards.length === 0 ? (
              <tr>
                <td colSpan="3">No boards found</td>
              </tr>
            ) : (
              boards.map((board) => (
                <tr key={board._id}>
                  <td>{board.boardName}</td>
                  <td>{board.slug}</td>
                  <td>
                    <button
                      className="edit"
                      onClick={() => handleEdit(board)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete"
                      onClick={() => handleDelete(board._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default BoardManagement;
